import * as THREE from 'three'
import Stage from '../Stage'

import Island from 'designer/geoHandlers/Components/Island'
import Section from 'designer/geoHandlers/Components/Section'

import SectionEditor from '../EditorPopup/SectionEditor'

class ModeSection {
  public select = (): {
    selection: Section[] | []
    selectionPoint: THREE.Vector3 | null
  } => {
    const {
      height: c_height,
      width: c_width,
      x: c_x,
      y: c_y,
    } = Stage.canvas.getBoundingClientRect()
    const { x, y } = Stage.mouseCords
    const pointer: THREE.Vector2 = new THREE.Vector2()
    pointer.x = ((x - c_x) / c_width) * 2 - 1
    pointer.y = -((y - c_y) / c_height) * 2 + 1
    Stage.rayCaster.setFromCamera(pointer, Stage.camera)
    const selection = Stage.rayCaster.intersectObjects(
      Stage.selectableSections,
      true
    )

    if (selection.length > 0) {
      const mesh = selection[0].object
      const island = mesh.parent as Island
      const section = island.section as Section
      // Stage.outlinePass.selectedObjects = [section]
      // ModeSection.stage.setSelectPoint3D(selection[0].point)
      return { selection: [section], selectionPoint: selection[0].point }
    } else {
      // Stage.outlinePass.selectedObjects = []
      return { selection: [], selectionPoint: null }
    }
  }

  public Editor = SectionEditor
  public name = 'Section'
}

export default ModeSection
